"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../constants");
const common_1 = __importDefault(require("./common"));
const { selectOneFromOptionsValidation } = common_1.default;
const validator = (schema) => (payload) => schema.validate(payload, { abortEarly: false, convert: true });
const UserUpdateSchema = joi_1.default
    .object({
    email: common_1.default.email,
    displayName: common_1.default.name,
    userPrivacy: common_1.default.postPrivacy,
    socialMediaAccounts: common_1.default.socialMediaAccounts(true),
    phoneNumber: common_1.default.phoneNumber.allow(""),
    bio: common_1.default.bio.allow(""),
    location: common_1.default.location,
    unitPreference: common_1.default.unitPreference,
})
    .min(1);
const RespondToTrainerInviteSchema = joi_1.default.object({
    inviteId: joi_1.default.string().required(),
    inviteResponse: selectOneFromOptionsValidation(constants_1.InviteResponse).lowercase().required(),
});
module.exports = {
    UserUpdateSchema: validator(UserUpdateSchema),
    RespondToTrainerInviteSchema: validator(RespondToTrainerInviteSchema),
};
//# sourceMappingURL=user.js.map